module.exports = __webpack_public_path__ + "img/CamperTrader_Branding.cb087e5c.webp";